import React from 'react';
import PropTypes from 'prop-types';
import { Card, Statistic, Divider } from 'antd';
import InvertorsPower from '../../components/analytics/invertorspower';

const YieldChart = ({
    roundedGeneration,
    earningsValue,
    fullLoadHours,
}) => {
    return (
        <div className="yieldChart">
            <div className="chart">
                <div className="summaryBoxes">
                    <Card className="summaryBox">
                        <Statistic
                            title="Daily Generation"
                            value={roundedGeneration}
                            suffix="kWh"
                            prefix={null}
                        />
                    </Card>
                    <Divider type="vertical" />
                    <Card className="summaryBox">
                        <Statistic
                            title="Daily Earnings"
                            value={earningsValue}
                            precision={2}
                            suffix="rmb"
                            prefix="¥"
                        />
                    </Card>
                    <Divider type="vertical" />
                    <Card className="summaryBox">
                        <Statistic
                            title="Full Load Hours"
                            value={fullLoadHours || 0}
                            suffix="hours"
                        />
                    </Card>
                </div>
                <InvertorsPower />
            </div>
        </div>
    );
};

YieldChart.propTypes = {
    roundedGeneration: PropTypes.number.isRequired,
    earningsValue: PropTypes.number.isRequired,
    fullLoadHours: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default YieldChart;
